/**
 * Parts of the app that are switched off rather than deleted.
 *
 * The community catalog — the Filmwerkstatt, adding films by hand, the
 * workshop numbers on the home and account screens — stopped making sense the
 * day availability started coming from TMDB: there is nothing left for people
 * to type in. The screens and their code stay, so the decision can be undone
 * with a build flag instead of an archaeology project. The server has the
 * matching switch (`COMMUNITY_CATALOG`); both have to be on together.
 */
export const COMMUNITY_CATALOG = import.meta.env.VITE_COMMUNITY_CATALOG === 'on';
